import style from "./style.module.css"
import {register} from 'swiper/element/bundle';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import BaseApi from "../../../services/Api";
import React, { useEffect, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import leftArrow from "../../../images/fixedAnimals/LeftArrow.svg"
import rightArrow from "../../../images/fixedAnimals/RightArrow.svg"
import ModalAnimal from "../../Modals/ModalInfoAnimal";
import axios from "axios";
import {formatDuration, intervalToDuration} from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

register();

export default function PinnedAnimals(props) {
    const sliderRef = useRef(null);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleDate = (birthday) => {
        const todayDate = new Date();
        const birthdayDate = new Date(birthday);

        let duration = intervalToDuration({
            start: birthdayDate,
            end: todayDate,
        });
        if (duration.years === 0 && duration.months > 0) {
            if(duration.months == 1){
                return `${duration.months} mes`;

            }else{
                return `${duration.months} meses`;

            }
        } else

        {
            if(duration.years==0 && duration.months == 0){
                if(duration.days == 1){
                    return `${duration.days} dia`;
                }else{
                    return `${duration.days} dias`;
                }
            }else{
                return formatDuration(duration, {
                    format: ['years'],
                    delimiter: ' e ',
                    locale: ptBR
                });
            }

        }
    }

    return (
        <>

        <div className={style.rectangle}>
            <div className={style.dimension}>
            {((props.pinnedAmount > 1) || (props.pinnedAmount==1 && props.bannerData.data[3])) &&
            <div className={style.arrows}>
                <div onClick={handlePrev}> 
                    <img className={style.dimensionArrow} src = {leftArrow} alt="seta Esquerda"/>
                </div>
                <div onClick={handleNext}>
                    <img className={style.dimensionArrow} src = {rightArrow} alt="seta Direita"/>
                </div>
            </div>
            }
            <Swiper
                className={style.swiperEdit}
                slidesPerView={1}
                pagination={{clickable: true}}
                ref={sliderRef}
                loop = {true}
            >
              {(props.pinnedAmount>=1) && (
                <>

                {props.animalData.map((item)=>
                (
                    <SwiperSlide key={item.id}>
                        <div>
                            <div className="position-relative">
                                <div className={style.bannerDescription}>
                                    <p className={style.textBanner}>{item.banner.callout_phrase}</p>
                                    {(item.banner.button_link != null && item.banner.button_text != null) && (
                                        <div className={style.buttonInformation}>
                                            <a className={style.bannerButton} href={item.banner.button_link} target="_blank" alt="botão banner">
                                                {item.banner.button_text}
                                            </a>
                                        </div>  
                                    )}
                                </div>
                                <img src={item.banner.image} alt="banner" className={style.banner}/>
                            </div>
                            <div className={style.animalBanner}>
                                <div className={style.imgAndDescription}>
                                    <div className={style.masking}>
                                        <img src={item.animal.animal_img} className={style.imgMask} alt="imagem animais" />
                                    </div>
                                    <div className={style.textDescription}>
                                        <h4 className={`text - left justify-content-start mb-0  ${style.animalName}`}>{item.animal.name}, {handleDate(item.animal.birthday)}</h4>
                                        <p className={style.description}>{item.animal.description}</p>
                                    </div>
                                </div>
                                <div className={style.positionAdoteButton}>
                                    <ModalAnimal
                                        idAnimal={item.animal.id}
                                    >
                                        <button className={style.adoteButton} target="_blank" alt="adotar">
                                            ADOTAR
                                        </button>
                                    </ModalAnimal>

                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
                </>
              )}
                {props.bannerData.data[3] && (
                    <SwiperSlide key={props.bannerData.data[3].id}>
                        <div>
                            <div className={style.dimensionBannerSolo}>
                                <div className={style.bannerDescriptionSolo}>
                                    <p>{props.bannerData.data[3].callout_phrase}</p>
                                    {(props.bannerData.data[3].button_link != null && props.bannerData.data[3].button_text != null) && (
                                        <div className={style.buttonInformation}>
                                            <a className={style.bannerButton} href={props.bannerData.data[3].button_link} target="_blank" alt="botão banner">
                                                {props.bannerData.data[3].button_text}
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <img src={props.bannerData.data[3].image} alt="banner" className={style.bannerSolo}/>
                            </div>
                        </div>
                    </SwiperSlide>
                )}
            </Swiper>
            </div>
        </div>
        </>
    )
}